var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.bannerClassName }, [
    _c(
      "div",
      { staticClass: "entrance_banner", attrs: { id: "entrance_banner" } },
      [
        _c(
          "div",
          { ref: "swiperEl", staticClass: "swiper swiper-no-swiping" },
          [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              [
                _vm.isUseEntranceAd
                  ? _c(
                      "div",
                      { staticClass: "swiper-slide" },
                      [
                        _c("AdBanner", {
                          attrs: {
                            grpid: _vm.grpid,
                            "ad-unit": _vm.bannerAdUnit,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.bannerList, function (banner) {
                  return _c(
                    "div",
                    { staticClass: "swiper-slide" },
                    [
                      _c("Banner", {
                        attrs: {
                          image: banner.imageUrl,
                          link: _vm.prependHttpPrefix(banner.linkUrl),
                        },
                      }),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm.isShowPagination
      ? _c("div", { staticClass: "swiper-navigation" }, [
          _c(
            "button",
            { staticClass: "swiper-prev", on: { click: _vm.goPrev } },
            [
              _c("span", { staticClass: "ico_arr" }),
              _vm._v(" "),
              _c("span", { staticClass: "sr_only" }, [_vm._v("이전 배너")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "swiper-next", on: { click: _vm.goNext } },
            [
              _c("span", { staticClass: "ico_arr" }),
              _vm._v(" "),
              _c("span", { staticClass: "sr_only" }, [_vm._v("다음 배너")]),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isShowPagination
      ? _c("div", {
          staticClass: "swiper-pagination",
          attrs: { slot: "pagination" },
          slot: "pagination",
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }